// extracted by mini-css-extract-plugin
export default {"containar":"ProductCard_containar__S7-fg","Offers":"ProductCard_Offers__wUQe2","productName":"ProductCard_productName__O0w8q","para":"ProductCard_para__G+wTa"};